export default __webpack_public_path__ + "static/image 2-3655cce2fd538392475ab9720b354874.jpeg";